import React, { useState } from "react";

const CoreComponent35 = ({ pokerdevcompany }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div>
      <div className="row mt-2 d-flex justify-content-center">
        {pokerdevcompany.map((val, i) => (
          <div
            key={i}
            className="col-lg-4 col-md-6 text-start mb-4"
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div
              className="p-3 mb-4 mt-3 h-100"
              style={{
                // border: "2px solid", // required for border-image
                // borderImage: "linear-gradient(90deg, #F15A24 0%, #F1CC31 100%) 1",
                borderRadius: "10px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                boxShadow:
                  hoveredIndex === i
                    ? "0 10px 25px rgba(0,0,0,0.2)"
                    : "0 2px 8px rgba(0,0,0,0.05)",
                transform: hoveredIndex === i ? "scale(1.03)" : "scale(1)",
              }}
            >
              <img
                src={val.icon}
                alt=""
                className="mx-0 mt-2 pt-1 icon-logo"
                style={{
                  width: hoveredIndex === i ? 70 : 50,
                  height: hoveredIndex === i ? 70 : 50,
                  transition: "all 0.3s ease",
                }}
              />
              <div>
                <h3
                  className="fs-5 h3-heading mb-2 text-start pt-1"
                  style={{
                    transition: "all 0.3s ease",
                    transform: hoveredIndex === i ? "scale(1.08)" : "scale(1)",
                    color: hoveredIndex === i ? "black" : "inherit",
                  }}
                >
                  {val.title}
                </h3>
                <p
                  className="fs-6 h3-para"
                  style={{
                    transition: "all 0.3s ease",
                    transform:
                      hoveredIndex === i ? "translateX(5px)" : "translateX(0)",
                    color: hoveredIndex === i ? "#555" : "#333",
                  }}
                >
                  {val.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreComponent35;
